import { Routes, RouterModule } from '@angular/router';
import { SingleComponent } from './single.component';

const routes: Routes = [
    {
        path: '',
        component: SingleComponent
    },
];

export const SingleRoutes = RouterModule.forChild(routes);
